var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAidaLogoNewLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03085 33.5249L0.822571 36.5214C0.453417 36.7331 0 36.4644 0 36.0369L0.0200627 1.33652C0.0200627 0.310535 1.11549 -0.332743 1.99022 0.180251L19.2361 10.261C19.4408 10.3791 19.5651 10.5989 19.5651 10.8351V17.3126C19.5651 17.6587 19.192 17.8785 18.8991 17.7035L6.45618 10.3424L6.44012 32.8164C6.44012 33.1096 6.28364 33.3824 6.03085 33.5249ZM25.5559 7.18302L25.5398 29.657L13.0969 22.296C12.8 22.1209 12.4308 22.3367 12.4308 22.6868V29.1644C12.4308 29.4005 12.5552 29.6204 12.7599 29.7385L30.0058 39.8192C30.8805 40.3322 31.9799 39.693 31.9799 38.6629L32 3.96256C32 3.53507 31.5466 3.26636 31.1774 3.47807L25.9692 6.4746C25.7164 6.62117 25.5599 6.88988 25.5599 7.18302H25.5559Z",
    fill: "url(#paint0_linear_5474_1384)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5474_1384",
    x1: -0.513605,
    y1: 1.78845,
    x2: 55.9823,
    y2: 62.3123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9803FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8809F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4026D4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAidaLogoNewLight);
export default __webpack_public_path__ + "static/media/AIDA_logo_new_light.ed6396621863e0d9cfe3e57ead39785b.svg";
export { ForwardRef as ReactComponent };